export const translations = {
  en: {
    url: {
      complaintInfoPage: 'complaint',
    },
    order: {
      list: {
        allOrders: 'All Orders',
        youDoNotHaveAnyOrdersYet: 'You do not have any orders yet',
        discoverFirstOrder:
          'Discover our full range and make your first order.',
        shopNow: 'Shop now',
        myOrders: 'My Orders',
      },
      details: {
        headline: 'Order details',
        orderNumberLabel: 'Order number',
      },
      actions: {
        returnOrder: 'Return order*',
        cancelOrder: 'Cancel order',
        changeOrCancelMyOrder: 'Change or cancel my order',
        whatsapp: 'Whatsapp',
        phone: 'Phone',
      },
      returns: {
        withinDaysFromPurchase:
          '*Within {maxVisibleReturnDays} days from the date of purchase.',
        downloadReturnsLabel: 'Download returns label',
        showReturnsQrCode: 'Show returns QR code',
        saveQrAsPicture: 'Download QR Code',
        registeredTitle: 'Returns are registered',
        registeredContent:
          'Your order is in the returns department. We will wait until the parcel has arrived.',
      },
      storno: {
        info: 'If you have just sent your order today and you have not yet received a shipping confirmation, a cancellation or change may be possible in individual cases. For orders on prepayment, which have not been paid yet, a cancellation is possible in any case. Our Customer Happiness Team will gladly take care of it.',
        haveFollowingInfo: 'Have the following info ready',
        orderNumberLabel: 'Order number: {orderNumber}',
        itemNumberInfo: 'Item number for a cancellation of individual items',
      },
      status: {
        orderCanceled: 'Order canceled',
        orderCanceledInfo: 'The order was successfully canceled on {date}.',
        refundRegistered: 'Returns are registered',
        refunding: 'Your return will be processed',
        inProgress: 'Order is being processed',
        orderHasBeenReceivedInfo:
          'You will receive an email as soon as your order is ready for shipment.',
        refunded: 'Return is completed',
        fulfilled: 'Order is completed',
        unfulfilled: 'Order has been received',
        noProcessingPossible: 'No processing possible',
        orderIsCompleted: 'Order is completed',
        orderHasBeenReceived: 'Order has been received',
      },
      totals: {
        orderTotal: 'Order total',
        discounts: 'Discounts',
        deliveryCosts: 'Delivery costs',
        totalInclVat: 'incl. VAT',
      },
      shipping: {
        shippingMethod: 'Shipping method',
      },
      payment: {
        paymentMethod: 'Payment Method',
        paymentStatus: 'Payment Status',
        paid: 'Paid',
        pending: 'Pending',
        shopifyInstallments: 'PayPal / Google Pay / Apple Pay',
        creditCard: 'Credit Card',
        prepayment: 'Prepayment',
        giftCard: 'Gift Card',
        invoice: 'Invoice',
        noPaymentRequired: 'No Payment required',
      },
      addresses: {
        billing: 'Billing address',
        shipping: 'Shipping address',
      },
    },
  },
  de: {
    url: {
      complaintInfoPage: 'reklamation',
    },
    order: {
      list: {
        allOrders: 'Alle Bestellungen',
        youDoNotHaveAnyOrdersYet: 'Du hast noch keine Bestellungen',
        discoverFirstOrder:
          'Entdecke unser ganzes Sortiment und mache deine erste Bestellung.',
        shopNow: 'Jetzt einkaufen',
        myOrders: 'Meine Bestellungen',
      },
      details: {
        headline: 'Bestelldetails',
        orderNumberLabel: 'Bestellnummer',
      },
      actions: {
        returnOrder: 'Bestellung retournieren*',
        cancelOrder: 'Bestellung stornieren',
        changeOrCancelMyOrder: 'Meine Bestellung ändern oder stornieren.',
        whatsapp: 'Whatsapp',
        phone: 'Telefon',
      },
      returns: {
        withinDaysFromPurchase:
          '*Innerhalb von {maxVisibleReturnDays} Tagen nach Kaufabschluss.',
        downloadReturnsLabel: 'Retourenlabel herunterladen',
        showReturnsQrCode: 'Retoure QR Code anzeigen',
        saveQrAsPicture: 'QR Code herunterladen',
        registeredTitle: 'Retoure ist angemeldet',
        registeredContent:
          'Deine Bestellung befindet sich in der Retoure. Wir warten bis das Paket bei uns eingetroffen ist.',
      },
      storno: {
        info: 'Wenn du deine Bestellung heute erst abgeschickt hast und du noch keine Versandbestätigung erhalten hast, kann eine Stornierung oder Änderung in Einzelfällen möglich sein. Bei Bestellungen auf Vorkasse, die noch nicht bezahlt wurden, ist eine Stornierung in jedem Fall möglich. Unser Customer Happiness Team kümmert sich gerne darum',
        haveFollowingInfo: 'Halte folgende Infos bereit',
        orderNumberLabel: 'Bestellnummer: {orderNumber}',
        itemNumberInfo: 'Artikelnummer bei einer Stornierung einzelner Artikel',
      },
      status: {
        orderCanceled: 'Bestellung storniert',
        orderCanceledInfo:
          'Die Bestellung wurde erfolgreich am {date} storniert.',
        refundRegistered: 'Retoure ist angemeldet',
        inProgress: 'Bestellung wird bearbeitet',
        orderHasBeenReceivedInfo:
          'Du erhältst eine E-Mail, sobald deine Bestellung versandbereit ist.',
        refunding: 'Deine Retoure wird bearbeitet',
        refunded: 'Retoure ist abgeschlossen',
        fulfilled: 'Bestellung ist abgeschlossen',
        unfulfilled: 'Auftrag ist eingegangen',
        noProcessingPossible: 'Keine Verarbeitung möglich',
        orderIsCompleted: 'Bestellung ist abgeschlossen',
        orderHasBeenReceived: 'Auftrag ist eingegangen',
      },
      totals: {
        orderTotal: 'Bestellsumme',
        discounts: 'Rabatte',
        deliveryCosts: 'Lieferkosten',
        totalInclVat: 'inkl. gesetzl. MwSt',
      },
      shipping: {
        shippingMethod: 'Versandart',
      },
      payment: {
        paymentMethod: 'Zahlungsart',
        paymentStatus: 'Bezahlstatus',
        paid: 'Bezahlt',
        pending: 'Ausstehend',
        shopifyInstallments: 'PayPal / Google Pay / Apple Pay',
        creditCard: 'Kreditkarte',
        prepayment: 'Vorkasse',
        giftCard: 'Geschenkgutschein',
        invoice: 'Rechnung',
        noPaymentRequired: 'Keine Zahlung nötig',
      },
      addresses: {
        billing: 'Rechnungsadresse',
        shipping: 'Lieferadresse',
      },
    },
  },
  fr: {
    url: {
      complaintInfoPage: 'reclamation',
    },
    order: {
      list: {
        allOrders: 'Tous les ordres',
        youDoNotHaveAnyOrdersYet: "Vous n'avez pas encore de commandes",
        discoverFirstOrder:
          'Découvrez notre gamme complète et passez votre première commande.',
        shopNow: 'Acheter maintenant',
        myOrders: 'Mes commandes',
      },
      details: {
        headline: 'Détails de commande',
        orderNumberLabel: 'Numéro de commande',
      },
      actions: {
        returnOrder: 'Renvoyer la commande*',
        cancelOrder: 'Annuler la commande',
        changeOrCancelMyOrder: 'Modifier ou annuler ma commande',
        whatsapp: 'Whatsapp',
        phone: 'Téléphone',
      },
      returns: {
        withinDaysFromPurchase:
          "*Dans les {maxVisibleReturnDays} jours suivant la date d'achat.",
        downloadReturnsLabel: "Télécharger l'étiquette de retour",
        showReturnsQrCode: 'Afficher le code QR des retours',
        saveQrAsPicture: 'Télécharger QR Code',
        registeredTitle: 'Les retours sont enregistrés',
        registeredContent:
          'Votre commande est en cours de retour. Nous attendrons que le colis soit arrivé.',
      },
      storno: {
        info: "Si vous venez d'envoyer votre commande aujourd'hui et que vous n'avez pas encore reçu de confirmation d'expédition, une annulation ou une modification est possible dans certains cas. Pour les commandes en prépaiement, qui n'ont pas encore été payées, une annulation est possible dans tous les cas. Notre équipe du service client s'en chargera volontiers",
        haveFollowingInfo: 'Préparez les informations suivantes',
        orderNumberLabel: 'Numéro de commande: {orderNumber}',
        itemNumberInfo:
          "Numéro d'article pour une annulation d'articles individuels",
      },
      status: {
        orderCanceled: 'Commande annulée',
        orderCanceledInfo: 'La commande a été annulée avec succès le {date}.',
        refundRegistered: 'Les retours sont enregistrés',
        inProgress: 'La commande est en cours de traitement',
        orderHasBeenReceivedInfo:
          'Vous recevrez un e-mail dès que votre commande sera prête à être expédiée.',
        refunding: 'Votre retour sera traité',
        refunded: 'Le retour est terminé',
        fulfilled: 'La commande est terminée',
        unfulfilled: 'La commande a été reçue',
        noProcessingPossible: 'Pas de traitement possible',
        orderIsCompleted: 'La commande est terminée',
        orderHasBeenReceived: 'La commande a été reçue',
      },
      totals: {
        orderTotal: 'Somme de la commande',
        discounts: 'Remises',
        deliveryCosts: 'Frais de port',
        totalInclVat: 'incl. TVA',
      },
      shipping: {
        shippingMethod: 'Expédié par',
      },
      payment: {
        paymentMethod: 'Mode de paiement',
        paymentStatus: 'Statut du paiement',
        paid: 'Payé',
        pending: 'En attente',
        shopifyInstallments: 'PayPal / Google Pay / Apple Pay',
        creditCard: 'Carte de crédit',
        prepayment: 'Paiement anticipé',
        giftCard: 'Carte cadeau',
        invoice: 'Facture',
        noPaymentRequired: 'Aucun paiement requis',
      },
      addresses: {
        billing: 'Adresse de facturation',
        shipping: 'Adresse de livraison',
      },
    },
  },
  es: {
    url: {
      complaintInfoPage: 'reclamacion-repuestos',
    },
    order: {
      list: {
        allOrders: 'Todos los pedidos',
        youDoNotHaveAnyOrdersYet: 'Todavía no tiene ningún pedido',
        discoverFirstOrder:
          'Descubra toda nuestra gama y haga su primer pedido.',
        shopNow: 'Comprar ahora',
        myOrders: 'Mis pedidos',
      },
      details: {
        headline: 'Detalles del pedido',
        orderNumberLabel: 'Número de pedido',
      },
      actions: {
        returnOrder: 'Orden de devolución*',
        cancelOrder: 'Cancelar el pedido',
        changeOrCancelMyOrder: 'Cambiar o cancelar mi pedido',
        whatsapp: 'Whatsapp',
        phone: 'Teléfono',
      },
      returns: {
        withinDaysFromPurchase:
          '*Dentro de los {maxVisibleReturnDays} días desde la fecha de compra.',
        downloadReturnsLabel: 'Descargar etiqueta de devolución',
        showReturnsQrCode: 'Mostrar código QR de devoluciones',
        saveQrAsPicture: 'Descargar Código QR',
        registeredTitle: 'Las devoluciones se registran',
        registeredContent:
          'Su pedido está en el departamento de devoluciones. Esperaremos hasta que llegue el paquete.',
      },
      storno: {
        info: 'Si acaba de enviar su pedido hoy mismo y aún no ha recibido la confirmación de envío, es posible que una cancelación o cambio sea posible en casos individuales. Para pedidos con prepago que aún no hayan sido pagados, una cancelación es posible en cualquier caso. Nuestro Equipo de Atención al Cliente se encargará encantado',
        haveFollowingInfo: 'Tenga preparada la siguiente información',
        orderNumberLabel: 'Número de pedido: {orderNumber}',
        itemNumberInfo:
          'Número de artículo para una anulación de artículos individuales',
      },
      status: {
        orderCanceled: 'Pedido cancelado',
        orderCanceledInfo: 'El pedido fue cancelado con éxito el {date}.',
        refundRegistered: 'Las devoluciones se registran',
        inProgress: 'El pedido está en proceso',
        orderHasBeenReceivedInfo:
          'Recibirás un correo electrónico tan pronto como tu pedido esté listo para el envío.',
        refunding: 'Su devolución será procesada',
        refunded: 'La devolución se ha completado',
        fulfilled: 'Pedido completado',
        unfulfilled: 'Se ha recibido el pedido',
        noProcessingPossible: 'No es posible el procesamiento',
        orderIsCompleted: 'La devolución se ha completado',
        orderHasBeenReceived: 'Se ha recibido el pedido',
      },
      totals: {
        orderTotal: 'Total',
        discounts: 'Descuentos',
        deliveryCosts: 'Costos de envío',
        totalInclVat: 'incl. IVA',
      },
      shipping: {
        shippingMethod: 'Método de envío',
      },
      payment: {
        paymentMethod: 'Forma de pago',
        paymentStatus: 'Estado del pago',
        paid: 'Pagado',
        pending: 'Pendiente',
        shopifyInstallments: 'PayPal / Google Pay / Apple Pay',
        creditCard: 'Tarjeta de crédito',
        prepayment: 'Pago anticipado',
        giftCard: 'Tarjeta de regalo',
        invoice: 'Factura',
        noPaymentRequired: 'No es necesario pagar',
      },
      addresses: {
        billing: 'Dirección de facturación',
        shipping: 'Dirección de envío',
      },
    },
  },
  it: {
    url: {
      complaintInfoPage: 'reclamo',
    },
    order: {
      list: {
        allOrders: 'Tutti gli ordini',
        youDoNotHaveAnyOrdersYet: 'Non hai ancora ordini',
        discoverFirstOrder:
          'Scoprite la nostra gamma completa e fate il vostro primo ordine.',
        shopNow: 'Acquista ora',
        myOrders: 'I miei ordini',
      },
      details: {
        headline: "Dettagli dell'ordine",
        orderNumberLabel: "Numero d'ordine",
      },
      actions: {
        returnOrder: 'Ordine di reso*',
        cancelOrder: 'Annulla ordine',
        changeOrCancelMyOrder: 'Desidero modificare il mio ordine o annullarlo',
        whatsapp: 'Whatsapp',
        phone: 'Telefono',
      },
      returns: {
        withinDaysFromPurchase:
          '*Entro {maxVisibleReturnDays} giorni dalla data di acquisto.',
        downloadReturnsLabel: "Scarica l'etichetta di reso",
        showReturnsQrCode: 'Mostra il codice QR di ritorno',
        saveQrAsPicture: 'Scarica Codice QR',
        registeredTitle: 'I resi sono registrati',
        registeredContent:
          "Il tuo ordine è nel reparto resi. Attenderemo l'arrivo del pacco.",
      },
      storno: {
        info: "Se hai appena inviato l'ordine e non hai ancora ricevuto la conferma di spedizione, in alcuni casi puoi annullare o modificare l'ordine. L'annullamento è possibile in ogni caso per gli ordini pagati in anticipo e non ancora saldati. Il nostro Customer Happiness Team sarà lieto di occuparsene:",
        haveFollowingInfo: 'Preparate le seguenti informazioni',
        orderNumberLabel: "Numero d'ordine: {orderNumber}",
        itemNumberInfo:
          "Numero di articolo per l'annullamento di singoli articoli",
      },
      status: {
        orderCanceled: 'Ordine annullato',
        orderCanceledInfo: "L'ordine è stato annullato con successo il {date}.",
        refundRegistered: 'I resi sono registrati',
        inProgress: "L'ordine è in fase di elaborazione",
        orderHasBeenReceivedInfo:
          'Riceverai un' +
          'e-mail non appena il tuo ordine sarà pronto per la spedizione.',
        refunding: 'Il tuo reso sarà elaborato',
        refunded: 'Il reso è stato completato',
        fulfilled: 'Ordine completato',
        unfulfilled: 'Abbiamo ricevuto il tuo ordine',
        noProcessingPossible: "L'elaborazione non è possibile",
        orderIsCompleted: 'Ordine completato',
        orderHasBeenReceived: 'Abbiamo ricevuto il tuo ordine',
      },
      totals: {
        orderTotal: "Totale dell'ordine",
        discounts: 'Sconti',
        deliveryCosts: 'Spese di spedizione',
        totalInclVat: 'incl. IVA',
      },
      shipping: {
        shippingMethod: 'Tipo di spedizione',
      },
      payment: {
        paymentMethod: 'Modalità di pagamento',
        paymentStatus: 'Stato del pagamento',
        paid: 'Pagato',
        pending: 'In sospeso',
        shopifyInstallments: 'PayPal / Google Pay / Apple Pay',
        creditCard: 'Carta di credito',
        prepayment: 'Pagamento anticipato',
        giftCard: 'Carta regalo',
        invoice: 'Fattura',
        noPaymentRequired: 'Nessun pagamento richiesto',
      },
      addresses: {
        billing: 'Indirizzo di fatturazione',
        shipping: 'Indirizzo di spedizione',
      },
    },
  },
  da: {
    url: {
      complaintInfoPage: 'reklamation-reservedele',
    },
    order: {
      list: {
        allOrders: 'Til mine ordrer',
        youDoNotHaveAnyOrdersYet: 'Du har endnu ikke nogen ordrer',
        discoverFirstOrder:
          'Se hele vores sortiment, og bestil din første ordre.',
        shopNow: 'Shop nu',
        myOrders: 'Mine bestillinger',
      },
      details: {
        headline: 'Bestil detaljer',
        orderNumberLabel: 'Ordrenummer',
      },
      actions: {
        returnOrder: 'Returneringsordre*',
        cancelOrder: 'Annuller bestilling',
        changeOrCancelMyOrder: 'Ændre eller annullere min ordre',
        whatsapp: 'Whatsapp',
        phone: 'Telefon',
      },
      returns: {
        withinDaysFromPurchase:
          '* Inden for {maxVisibleReturnDays} dage fra købsdatoen.',
        downloadReturnsLabel: 'Download returlabel',
        showReturnsQrCode: 'Vis returnering af QR-kode',
        saveQrAsPicture: 'Download QR-kode',
        registeredTitle: 'Returneringer registreres',
        registeredContent:
          'Din ordre er i returafdelingen. Vi venter, indtil pakken er ankommet.',
      },
      storno: {
        info: 'Hvis du lige har sendt din bestilling i dag, og du endnu ikke har modtaget en forsendelsesbekræftelse, kan det i enkelte tilfælde være muligt at annullere eller ændre bestillingen. For ordrer på forudbetaling, som endnu ikke er betalt, er en annullering under alle omstændigheder mulig. Vores Customer Happiness Team tager sig gerne af det',
        haveFollowingInfo: 'Hav følgende oplysninger klar',
        orderNumberLabel: 'Ordrenummer: {orderNumber}',
        itemNumberInfo: 'Varenummer for en annullering af individuelle varer',
      },
      status: {
        orderCanceled: 'Ordre annulleret',
        orderCanceledInfo: 'Bestillingen blev annulleret den {date}.',
        refundRegistered: 'Returneringer registreres',
        inProgress: 'Ordren er ved at blive behandlet',
        refunding: 'Din returnering vil blive behandlet',
        refunded: 'Returneringen er afsluttet',
        fulfilled: 'Ordren er afsluttet',
        unfulfilled: 'Ordren er blevet modtaget',
        noProcessingPossible: 'Ingen forarbejdning mulig',
        orderIsCompleted: 'Ordren er afsluttet',
        orderHasBeenReceived: 'Ordren er blevet modtaget',
      },
      totals: {
        orderTotal: 'Order total',
        discounts: 'Rabat',
        deliveryCosts: 'Fragtomkostninger',
        totalInclVat: 'inkl. moms',
      },
      shipping: {
        shippingMethod: 'Forsendelsesmetode',
      },
      payment: {
        paymentMethod: 'Betalingsmetode',
        paymentStatus: 'Betalingsstatus',
        paid: 'Betalt',
        pending: 'Åbn',
        shopifyInstallments: 'PayPal / Google Pay / Apple Pay',
        creditCard: 'Kreditkort',
        prepayment: 'Forudbetaling',
        giftCard: 'Gavekort',
        invoice: 'Faktura',
        noPaymentRequired: 'Ingen betaling kræves',
      },
      addresses: {
        billing: 'Faktureringsadresse',
        shipping: 'Leveringsadresse',
      },
    },
  },
}
